<template>
  <div>
    <div class="dm-links-div">
      <h1>
        <div>Bet365 Accounts</div>
      </h1>
    </div>

    <div>
      <a href="/apps/script-tags/data-manager">Back to data manager</a>
    </div>

    <div style="width: 100%;">
      <form @submit="save">
        <table style="width: 100%;">
          <tr style="text-decoration: underline;">
            <td>#</td>
            <td>User</td>
            <td>Password</td>
            <td>Account</td>
            <td>Geo</td>
            <td>PO</td>
            <td>Actions</td>
          </tr>

          <tr v-for="row of rows" :key="row.id">
            <td>{{ row.id }}</td>

            <td>
              <div v-if="!row.edit">{{ row.username }}</div>
              <b-form-input v-if="row.edit" type="text" v-model.trim="row.username" placeholder="Username" />
            </td>

            <td>
              <div v-if="!row.edit">{{ row.password }}</div>
              <b-form-input v-if="row.edit" type="text" v-model.trim="row.password" placeholder="Password" />
            </td>

            <td>
              <div v-if="!row.edit">{{ row.account }}</div>
              <b-form-input :disabled="!userHasPermission('admin')" v-if="row.edit" type="text"
                v-model.trim="row.account" placeholder="Account" />
            </td>

            <td>
              <div v-if="!row.edit">{{ row.geo }}</div>
              <div v-if="row.edit">
                <cool-select v-model="geoSelected" :items="geosSelect" text="label" value="value" />
                <ul class="selected-items" v-if="row.geo">
                  <li>
                    <i class="fa fa-times del-x" @click="removeGeo(row)" aria-hidden="true"></i>
                    <span>{{ geoSelected || row.geo }}</span>
                  </li>
                </ul>
              </div>
            </td>

            <td>
              <div v-if="!row.edit">{{ row.po }}</div>
              <b-form-input :disabled="!userHasPermission('admin')" v-if="row.edit" type="text" v-model.trim="row.po"
                placeholder="PO" />
            </td>

            <td>
              <div v-if="!row.edit">
                <a v-if="isAdmin" class="btn btn-primary" href="javascript:void(0);" @click="editRow(row.id)">Edit</a>
                <a v-if="isAdmin" class="btn btn-primary" href="javascript:void(0);"
                  @click="deleteEntity(row.id)">Delete</a>
              </div>
              <div v-if="row.edit">
                <a class="btn btn-success" href="javascript:void(0);" @click="saveEditRow(row.id)">Save</a>
                <a class="btn btn-primary" href="javascript:void(0);" @click="cancelEditRow(row.id)">Cancel</a>
              </div>
            </td>
          </tr>

          <tr v-if="isAdmin && showNewRow">
            <td></td>
            <td><b-form-input type="text" v-model="newRow.username" placeholder="Username" /></td>
            <td><b-form-input type="text" v-model="newRow.password" placeholder="Password" /></td>
            <td><b-form-input :disabled="!userHasPermission('admin')" type="text" v-model="newRow.account"
                placeholder="Account" /></td>
            <td>
              <div>
                <cool-select v-model="newUserGeoSelected" :items="geosSelect" text="label" placeholder="Geo" />
              </div>
            </td>
            <td><b-form-input :disabled="!userHasPermission('admin')" type="text" v-model="newRow.po"
                placeholder="PO" /></td>
            <td><input type="submit" class="btn btn-success" value="Add" /></td>
          </tr>
        </table>
      </form>
    </div>
  </div>
</template>

<script>
import countries from '@/assets/countries.js';
import { CoolSelect } from 'vue-cool-select';
import 'vue-cool-select/dist/themes/bootstrap.css';

export default {
  name: 'Bet365Accounts',
  components: {
    CoolSelect
  },
  data() {
    return {
      all_geos: [],
      newRow: {
        id: 0,
        username: '',
        password: '',
        account: '',
        geo: '',
        po: ''
      },
      rows: [],
      showNewRow: true,
      isAdmin: true,
      sortOptions: {
        sortOrder: 'desc',
        sortByField: 'pid_text'
      },
      geoSelected: null,
      newUserGeoSelected: null,
      labelRelatedToGeo: null
    };
  },
  created() {
    this.getListData();

    const geoSelect = Object.keys(countries).map(code => ({
      label: countries[code],
      value: code
    }));
    this.all_geos = geoSelect;
  },
  computed: {
    geosSelect() {
      return Object.values(countries);
    }

  },
  methods: {
    async save(e) {
      e.preventDefault();
      const newUser = this.newRow;
      const countryCode = Object.keys(countries).find(key => countries[key] === this.newUserGeoSelected);
      newUser.geo = countryCode;

      const errors = await this.validateRowData(newUser);
      if (errors.length > 0) {
        this.notifyError("Failure reasons: " + errors.join(", "));
        return;
      }
      newUser.po = parseFloat(newUser.po);
      try {
        const data = await this.$http.post(this.resources.Management.saveBet365User, newUser);
        if (data.body.res !== "OK") {
          throw new Error()
        } else {
          this.newRow = { id: 0, username: '', password: '', account: '', geo: '', po: '' };
          this.newUserGeoSelected = null;
          this.geoSelected = null;
          this.getListData();
        }
      } catch (err) {
        this.notifyError("Error saving new User");
      }

    },
    async getListData() {
      const data = await this.$http.post(this.resources.Management.getBet365Users, {});
      for (let k in data.body.data) {
        data.body.data[k].edit = false;
      }
      this.rows = data.body.data;
    },
    editRow(id) {
      this.showNewRow = false;
      this.geoSelected = null;
      this.rows.forEach(row => {
        if (row.id === id) {
          row.edit = true;
          this.geoSelected = row.geo;
        } else {
          row.edit = false;
        }
      });
      this.newUserGeoSelected = null;
    },
    async saveEditRow(id) {
      let row = this.rows.find(r => r.id === id);
      if (!row) return;
      const copy = {
        username: row.username,
        password: row.password,
        account: row.account,
        po: row.po,
        id: row.id,
      };

      const isValidCode = countries[this.geoSelected] !== undefined;
      
      copy.geo = isValidCode
        ? this.geoSelected
        : Object.keys(countries).find(key => countries[key] === this.geoSelected);

      const errors = await this.validateRowData(copy);
      if (errors.length > 0) {
        this.notifyError("Failure reasons: " + errors.join(", "));
        return;
      }
      copy.po = parseFloat(copy.po);
      row.edit = false;

      try {
        const data = await this.$http.post(this.resources.Management.saveBet365User, copy);
        if (data.body.res !== "OK") throw new Error();
      } catch (err) {
        this.notifyError("Error editing user");
      }

      this.geoSelected = null;
      this.showNewRow = true;
      this.getListData();

    },
    async deleteEntity(id) {
      try {
        const data = await this.$http.post(this.resources.Management.deleteBet365User, { id });
        if (data.body.res !== "OK") throw new Error();
      } catch (err) {
        this.notifyError("Error deleting entity");
      }
      this.getListData();
    },
    async validateRowData(user) {
      const keys = Object.keys(user);
      const values = Object.values(user);
      let errors = [];

      for (let i = 0; i < keys.length; i++) {
        if (keys[i] === "id") continue;
        if (values[i] === "") {
          errors.push("All fields are required");
          break;
        }
      }

      for (let i = 0; i < keys.length; i++) {
        if (keys[i] === "id" || keys[i] === "po") continue;
        if (values[i].includes(" ") && keys[i] !== "account") {
          errors.push("No white spaces allowed");
          break;
        }
      }

      const poIdx = keys.indexOf("po");
      const poVal = values[poIdx];
      if (poVal !== undefined && poVal !== null && isNaN(Number(poVal))) {
        errors.push("PO should be a number");
      }

      return errors;
    },
    // onGeoSelected(row) {
    //   const selected = this.all_geos.find(g => g.label === row.geoSelected);
    //   if (selected) {
    //     row.geo = selected.label;
    //   }
    // },
    removeGeo(row) {
      row.geo = '';
      // row.geoSelected = null;
    },
    userHasPermission(role) {
      // Replace with actual permission logic
      return this.isAdmin;
    },
    notifyError(msg) {
      alert(msg); // Replace with actual toast/notify
    },
    getCountryLabel(code) {
      const match = Object.values(countries)
      return match ? match.label : code;
    },
    cancelEditRow(id) {
      this.showNewRow = true;
      this.rows.forEach(row => {
        if (row.id === id) {
          row.edit = false;
          this.geoSelected = null;
        }
      });
    }
  }
};
</script>

<style scoped>
/* .selected-items {
  background: #f1f0f0;
  padding: 2px 6px;
  border: 1px solid gainsboro;
  border-radius: 4px;
  max-width: 196px;
  display: flex;
  flex-wrap: wrap;
}
.selected-items > li {
  margin-right: 3px;
  padding: 2px 7px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  text-transform: capitalize;
  background: #e0e0e0;
}
.selected-items > li:hover {
  background: #dfdfdf;
  cursor: pointer;
}
.del-x {
  margin-right: 5px;
  color: red;
  cursor: pointer;
} */
</style>
